var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Tag")]),_vm._v(" "),_c('select-two',{attrs:{"options":_vm.tags,"formId":_vm.name+'tag_id',"valueDefault":_vm.dados.tags,"arrayValue":"nome"},on:{"selected":_vm.setTagId,"searching":_vm.getTags}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }